<template>
  <v-select
    v-bind="$attrs"
    v-model="selected"
    :items="applications"
    :label="label"
    multiple
    item-text="name"
    item-value="value"
    @change="change"
  >
    <template slot="append-outer">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">info</v-icon>
        </template>
        <span v-html="$t('When application is being selected, this product will become available only for it <br> becoming automatically unavailable for all applications not being selected. <br> When no application is selected, then product is available for all.')" />
      </v-tooltip>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'ApplicationSelect',

  props: {
    value: {
      type: [Array, null],
      default: null
    }
  },

  data () {
    return {
      selected: this.value
    }
  },

  computed: {
    applications () {
      return [
        {
          name: this.$t('StoreFront'),
          value: 'storefront'
        },
        {
          name: this.$t('Point of Sale'),
          value: 'pos'
        }
      ]
    },

    label () {
      let suffix = ''
      if (this.value === null ||
        (Array.isArray(this.value) && this.value.length === 0)) {
        suffix = ` (${this.$t('all')})`
      }

      return `${this.$t('Allowed Applications')}` + suffix
    }
  },

  methods: {
    change () {
      this.$emit('input', this.selected)
    }
  }
}
</script>
